import React from "react";
import {NodeOperations, TreeNodeHelper, TreeUtilities} from "./TreeHelper";
import Dict from "dict-lib";
import ReactDOM from "react-dom";
import {Button, Col, Modal, Row, OverlayTrigger, Grid, Tooltip} from "react-bootstrap";
import stylesScNavbar from "../../navbar/ScNavbar.module.css";
import {Typeahead} from "react-bootstrap-typeahead";
import stylesSCTree from "../SCTree.module.css";
import BUtils from "../../../utilities/BaseUtilities";
import {SCCombo} from "../../combo/SCCombo";
import {userService} from "../../../_redux/authentication/services/user.services";
import {BulkUpdate} from "../../../corpora/TreeNavbarMenu";
import {LexemeUtilities} from "../../../lexeme/page/editor/LexemeHelper";
import {Notifications} from "../../../utilities/DictUtilities";
import ReactTooltip from "react-tooltip";
import {SCCheckbox} from "../../components";

export class TreeMissingWordsFinder extends React.Component {

    constructor(props) {
        super(props);
        this.langs = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_LANGUAGE');
        this.prefix = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_PREFIX');

        this.state = {
            showModal: false,
            selectedLang: Dict.t('NONE_F'),
            selectedExternalService: {},
            externalServices: [],
            tot: -1,
            infos: '',
            words: [],
            status: 'STOP',
            csvContent: {},
            selectedWordDoc: '',
            selectedWordTitle: '',
            blackListStatus: 'STOP'
        };
    }

    /*componentDidMount() {
        this.setState({showModal: true}, () => {
            Dict.call('/tree/getProjectName/' + userService.isLogged() + '/').then((projectName) => {
                this.setState({projectName});
            })
        });

    }*/

    componentDidMount() {
        this.setState({showModal: this.props.show});
        var retrieveItem = new Promise((resolve) => {
            if (typeof this.props.parentKey !== 'undefined' && this.props.parentKey !== 'ALL') {
                return resolve(TreeUtilities.loadNodeByProject(this.props.projectName, this.props.parentKey))
            } else {
                return resolve();
            }
        });

        retrieveItem.then((data) => {
            var langsList = [];
            if (typeof data !== 'undefined') {
                langsList = [{value: Dict.t('NONE_F'), text: Dict.t('NONE_F')}];
                data.forEach((item) => {
                    const alignValue = item.data[item.data.length - 1].value;
                    const exists1 = langsList.some(x => x.value === alignValue.lang1);
                    const exists2 = langsList.some(x => x.value === alignValue.lang2);

                    if (!exists1) {
                        langsList.push({value: alignValue.lang1, text: alignValue.lang1});
                    }
                    if (!exists2) {
                        langsList.push({value: alignValue.lang2, text: alignValue.lang2});
                    }
                });

                if (langsList.length > 1) {
                    langsList = langsList.filter(x => x.value !== undefined);
                }

            } else {
                langsList = this.langs !== null ? [Dict.t('NONE_F')].concat(this.langs.split(',')).map((item) => {
                    return {value: item, text: item};
                }) : [];
            }

            this.setState({langsList});
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.showModal === false && this.props.show === true) {
            this.setState({showModal: true}, () => {
                Dict.call('/tree/getProjectName/' + userService.isLogged() + '/').then((projectName) => {
                    this.setState({projectName});
                })
            });
        }
    }

    //_emptyModalContainer(callback) {
    //if (typeof callback === 'function') {
    // setTimeout(function () {
    //   ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
    /*callback();*/
    // }, 500);
    //}
    // }

    _close() {
        this.setState({showModal: false}, function () {
            this.props.callbackParentClose();
            // this._emptyModalContainer();
        }.bind(this));
    }

    _reset() {
        const status = 'STOP';
        const words = [];
        const infos = '';
        this.setState({
            status, words, infos
        });
    }

    _performAnalyze() {
        this.setState({status: 'ANALYZE', csvContent: {}})
        Dict.call('/tree/analyzeTreeMissingForms/' + this.state.projectName + '/' + this.state.selectedLang + '/' + this.props.parentKey + '/').then((result) => {
            this.setState({status: 'ANALYZED', tot: result.tot, list: result.list})
        })
    }

    _performRetrieve(index, item, analyzing) {
        if (index === 1) {
            var infos = {
                analyzing: item.filename,
                filename: null
            }

            this.setState({infos});
        }

        Dict.call('/tree/checkTreeMissingForms/' + this.state.projectName + '/' + item.id + '/' + item.docNum + '/' + this.state.selectedLang + '/' + LexemeUtilities.encodeUrl(JSON.stringify(this.state.selectedExternalService)) + '/').then((result) => {
            if (this.state.status === 'START') {
                if (typeof result.missingWords !== 'undefined' && result.missingWords.length > 0) {
                    var infos = {
                        analyzing,
                        index,
                        filename: item.filename,
                        length: result.missingWords.length
                    }
                    const words = this.state.words.concat(result.missingWords.map((word) => {
                        return {word, idDoc: result.idDoc, title: result.title, blacklisted: false}
                    }));
                    this.setState({infos, words});

                }
                var tot = this.state.tot;
                if (tot < 0) {
                    tot = result.tot;
                }

                this.setState({tot}, () => {
                    /*tot = 20;*/
                    if (index < tot /*&& this.state.words.length === 0*/) {
                        this._performRetrieve(index + 1, this.state.list[index], index < tot - 1 ? this.state.list[index + 1].filename : null)
                    } else {
                        Dict.call('/tree/retrieveBlackList/' + this.state.projectName + '/').then((blacklist) => {
                            const status = 'STOP';
                            const infos = 'Spoglio terminato';
                            var words = this.state.words;
                            words = Array.from(
                                new Set(words.map(item => JSON.stringify(item)))
                            ).map(str => JSON.parse(str));

                            words = words.filter((item) => {
                                return !blacklist.includes(item.word)
                            })

                            words.sort((a, b) => a.word.localeCompare(b.word, 'it', {sensitivity: 'base'}));

                            const csvContent = this._createCsvContent(words);

                            this.setState({
                                status, infos, words, csvContent
                            }, () => {
                                TreeUtilities.createFileData(words).then((resultData) => {
                                    Dict.call('/tree/saveMissingWords/' + this.state.projectName + '/' + resultData.filename + '/').then((result) => {

                                    })
                                });
                            });
                        })
                    }
                })
            } else {
                this._reset();
            }
        })
    }

    _createCsvContent(words) {
        const wordMap = new Map();

        words.forEach(({word, idDoc, title}) => {
            const key = `${title}|${idDoc}`; // chiave univoca per deduplicare
            if (!wordMap.has(word)) {
                wordMap.set(word, new Map([[key, {title, idDoc}]]));
            } else {
                wordMap.get(word).set(key, {title, idDoc});
            }
        });

        const csvRows = ["Parole non trovate, Documenti, Id"];

        wordMap.forEach((entryMap, word) => {
            const entries = Array.from(entryMap.values());
            const titles = entries.map(e => e.title).join("|");
            const ids = entries.map(e => e.idDoc).join("|");
            csvRows.push(`${word},"${titles}","${ids}"`);
        });

        const csvContent = csvRows.join("\n");
        return csvContent;
    }

    _parseCsv() {
        const lines = this.state.csvContent.trim().split('\n');
        const [header, ...rows] = lines;

        return rows.map((row) => {
            const [word, titleRaw, idDocRaw] = row.split(/,(?=")/); // split prima delle virgolette
            const titleList = titleRaw.replace(/"/g, '').split('|');
            const idDocList = idDocRaw.replace(/"/g, '').split('|');
            return {word, titleList, idDocList};
        });
    };

    _printGrid() {
        return (
            <Grid className={stylesScNavbar['tree-navbar-tools__missing_words__scrollable-grid']} fluid>
                <div className={stylesScNavbar['tree-navbar-tools__missing_words__fixed-header']}>

                    <Row style={{fontWeight: 'bold', borderBottom: '1px solid #ccc', padding: '8px 0'}}>
                        <Col xs={3}>Parole non trovate</Col>
                        <Col xs={6}>Documenti</Col>
                        <Col xs={3}>Inserisci in blacklist</Col>
                    </Row>
                </div>
                <div className={stylesScNavbar['tree-navbar-tools__missing_words__scrollable-body']}>
                    {this._parseCsv().map((itemmo, index) => {
                        const titleList = itemmo.titleList
                        const idDocList = itemmo.idDocList
                        const word = itemmo.word
                        const visibleIds = titleList.slice(0, 5);
                        const hiddenIds = titleList.slice(5).join(', ');
                        /*const visibleDocs = idDocList.slice(0, 5);
                        const hiddenDocs = idDocList.slice(5).join(', ');*/
                        const hasOverflow = titleList.length > 5;
                        const wordList = this.state.words;
                        const wordListItemAll = wordList.filter((wordListItemItem) => {
                            return wordListItemItem.word === word;
                        });

                        const wordListItemUnique = Array.from(
                            new Set(wordListItemAll.map(item => JSON.stringify(item)))
                        ).map(str => JSON.parse(str));

                        const visibleIdsClickable = visibleIds.map((item, indexVisible) => {
                            const selectedWordDoc = index + '-' + item;
                            const isSelected = selectedWordDoc === this.state.selectedWordDoc
                            return <div
                                className={BUtils.joinClasses(stylesScNavbar['tree-navbar-tools__missing_words-selectedWordDoc'], stylesScNavbar['tree-navbar-tools__missing_words-selectedWordDoc__selected--' + isSelected])}
                                onClick={() => {
                                    if (isSelected) {
                                        this.setState({selectedWordDoc: '', selectedWordTitle: ''})
                                    } else {
                                        const idToClick = wordListItemUnique[indexVisible].idDoc.replace(this.prefix, '');
                                        const nodePage = document.getElementById('node-page');
                                        nodePage.innerHTML = '';
                                        NodeOperations.getItemById(this.state.projectName, idToClick).then((retItem) => {
                                            this.props.callBackOpenItem(retItem);
                                        });
                                        const selectedWordTitle = {idDoc: wordListItemUnique[indexVisible].idDoc, index}
                                        this.setState({selectedWordDoc, selectedWordTitle});
                                    }
                                }}>{item}</div>
                        })

                        return (
                            <Row key={`${word}-${index}`}
                                 className={stylesScNavbar['tree-navbar-tools__missing_words_list__row']}>
                                <Col xs={3}>{word}</Col>
                                <Col xs={6}>
                                    {visibleIdsClickable}
                                    {hasOverflow && (
                                        <>
                                        <span style={{marginLeft: '6px', cursor: 'pointer', color: '#888'}} data-tip
                                              data-for={'tooltip-missing-word-docs-' + index}>
                    +{titleList.length - 5}
                  </span>
                                            <ReactTooltip id={'tooltip-missing-word-docs-' + index} type='info'
                                                          delayShow={20}
                                                          className={"tree-tool-tip"}> {`Altri ID: ${hiddenIds}`}</ReactTooltip>
                                        </>
                                    )}
                                    {/*<span style={{display: 'block'}}
                                          id={'missing-word-doc-title-' + index}>{this.state.selectedWordTitle !== '' && this.state.selectedWordTitle.index === index ? this.state.selectedWordTitle.title : ''}</span>*/}
                                </Col>
                                <Col xs={3}>
                                    <SCCheckbox key={"key-chk-missing-words-" + index}
                                                additionalClass={stylesScNavbar['tree-navbar-tools__missing_words-chk-blacklist']}
                                                checked={typeof wordListItemUnique !== "undefined" && wordListItemUnique.length > 0 && wordListItemUnique[0].blacklisted}
                                                label={''}
                                                id={'chk-missing-words-' + index}
                                                callbackParent={(id, newState) => {
                                                    wordList.find((wordItemBlacklist) => {
                                                        return wordItemBlacklist.word === wordListItemUnique[0].word;
                                                    }).blacklisted = newState;
                                                    this.setState({wordList})
                                                }}/>
                                </Col>
                            </Row>
                        );
                    })}
                </div>
            </Grid>
        );
    }

    render() {

        const service = this.state.selectedExternalService;
        const serviceFound = typeof service.apiName !== 'undefined' && service.apiName !== Dict.t('EXTERNAL_DICTIONARY_NOT_FOUND');
        const dictName = typeof service.apiName !== 'undefined' ? Dict.t('DICTIONARY') + ': ' + service.apiName : ''
        const infos = this.state.infos;
        var printInfos = '';
        const status = this.state.status;

        var printGrid = '';
        if (this.state.csvContent.length > 0) {
            printGrid = this._printGrid();
        }


        if (this.state.status === 'START' && infos === '') {
            printInfos = Dict.t('MISSING_WORDS_STARTED_WAIT') + ' ' + this.state.selectedLang;
        } else if (this.state.status === 'START' && infos.analyzing && infos.filename === null) {
            printInfos = Dict.t('MISSING_WORDS_STARTED_WAIT') + ' ' + this.state.selectedLang + '<br>Analisi in corso di:' + infos.analyzing;
        } else if (this.state.status === 'START' && typeof infos !== 'undefined' && infos !== '' && this.state.tot >= 0) {
            printInfos = infos.index + '/' + this.state.tot + ') ' + infos.filename + ' - ' + infos.length + ' parole trovate' + (typeof infos.analyzing !== 'undefined' && infos.analyzing !== null ? '<br>Analisi in corso di:' + infos.analyzing : '');
        } else if (this.state.status === 'STOP' && infos !== '') {
            printInfos = infos;
        } else {
            printInfos = '';
        }

        var title = '';
        if (this.props.parentKey === 'ALL') {
            title = Dict.t('TREE_MISSING_WORD_FINDER_ALL_OVER_THE_TREE');
        } else {
            title = Dict.t('TREE_MISSING_WORD_FINDER_IN') + ' ' + this.props.parentName;
        }

        return <Modal id={"tree_missing_word_finder"}
                      dialogClassName={stylesScNavbar['tree-navbar-tools-modal-dialog__missing_words']}
                      show={this.state.showModal} /*onHide={() => this._close()}*/
                      restoreFocus>
            <Modal.Header className={stylesScNavbar['search-modal-navbar']}>
                <Modal.Title><span
                    style={{fontWeight: 'bold'}}>{title}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingTop: '0px'}}>
                <Row className={stylesScNavbar['tree-navbar-tools__missing_words__first-row']}>
                    <Col lg={5} md={5}>
                        {typeof this.state.langsList !== 'undefined' ? <SCCombo options={this.state.langsList}
                                                                                value={this.state.selectedLang}
                                                                                disabled={this.state.status !== 'STOP'}
                                                                                label={Dict.t('ASSIGN_LANGUAGE')}
                                                                                callbackParent={(newState) => {
                                                                                    Dict.call('/tree/alignmentService/getScDictionariesByLang/' + this.state.projectName + '/' + newState + '/').then((result) => {
                                                                                        if (result.result === 'OK') {
                                                                                            const list = result.dicts;
                                                                                            const externalServices = list.map((item) => {
                                                                                                item.value = item.apiName;
                                                                                                item.text = item.apiName;
                                                                                                return item;
                                                                                            });
                                                                                            this.setState({
                                                                                                selectedLang: newState,
                                                                                                selectedExternalService: list.length > 0 ? list[0] : {apiName: Dict.t('EXTERNAL_DICTIONARY_NOT_FOUND')},
                                                                                                externalServices
                                                                                            });
                                                                                        } else {
                                                                                            Notifications.showErrorModalMessage('ignore:' + Dict.t('EXTERNAL_DICTIONARY_ERROR'), 3000);
                                                                                        }
                                                                                    })
                                                                                }}/> : ''}
                    </Col>
                    <Col lg={7} md={7}
                         className={BUtils.joinClasses(stylesScNavbar['tree-navbar-tools-modal-dialog__missing_words__third'], stylesScNavbar['tree-navbar-tools-modal-dialog__missing_words__third_combo--' + (this.state.externalServices.length > 1)])}>{this.state.externalServices.length > 1 ?
                        <SCCombo
                            key={'ext-svc-' + this.state.selectedLang}
                            options={this.state.externalServices}
                            value={this.state.selectedExternalService}
                            disabled={this.state.status !== 'STOP'}
                            label={Dict.t('AVAILABLE_DICTIONARIES')}
                            callbackParent={(newState) => {
                                const selectedExternalService = this.state.externalServices.find((item) => {
                                    return item.apiName === newState;
                                });
                                this.setState({selectedExternalService});
                            }}/> : dictName}</Col>
                </Row>
                <Row className={stylesScNavbar['tree-navbar-tools__missing_words__row']}>
                    <Col lg={status.startsWith('ANALYZE') ? 5 : 7}
                         md={status.startsWith('ANALYZE') ? 5 : 7} danger
                         dangerouslySetInnerHTML={{__html: printInfos}}/>
                    {status.startsWith('ANALYZE') ? <Col lg={2} md={2}
                                                         className={stylesScNavbar['tree-navbar-tools__missing_words_analyzed-result-col']}>{status === 'ANALYZED' ? (Dict.t('FOUND_PLUR') + ' ' + this.state.tot + ' ' + Dict.t('DOCS')) : Dict.t('ANALYZE_IN_PROGRESS')}</Col> : ''}
                    <Col lg={5} md={5} className={stylesScNavbar['tree-navbar-tools__missing_words__second-col']}>
                        {status === 'STOP' && this.state.words.length > 0 ?
                            <Button id={'DOWNLOAD_TEXT_MISSING_WORDS'}
                                    onClick={() => {
                                        const filteredCsvContent = this.state.csvContent
                                            .split('\n')
                                            .map(line => {
                                                const parts = line.split(',');
                                                return parts.length >= 2 ? `${parts[0]},${parts[1]}` : line;
                                            })
                                            .join('\n');

                                        const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(filteredCsvContent);
                                        const link = document.createElement("a");
                                        link.setAttribute("href", encodedUri);
                                        link.setAttribute("download", (this.props.parentKey === 'ALL' ? 'complete' : this.props.parentName) + '_' + this.state.selectedExternalService.apiName + '_' + this.state.selectedLang + '.csv');
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }}
                            ><b>{Dict.t('DOWNLOAD')}</b>
                            </Button> : ''}
                        {serviceFound && status === 'STOP' ? <Button
                            onClick={() => {
                                this._performAnalyze();
                            }}
                        >{Dict.t('START_ANALYZE_DOCS')}</Button> : ''}
                        {serviceFound && status === 'ANALYZED' || status === 'START' ? <Button
                            onClick={() => {
                                if (this.state.status === 'ANALYZED') {
                                    const status = 'START';
                                    this.setState({
                                        status
                                    }, () => {
                                        this._performRetrieve(1, this.state.list[0]);
                                    })
                                } else {
                                    this._reset();
                                }
                            }}
                        ><b>{status === 'ANALYZED' ? Dict.t('START') : 'STOP'}</b></Button> : ''}
                        {status === 'ANALYZED' || status === 'STOP' ? <Button
                            onClick={() => {
                                this._reset();
                            }}
                        >{Dict.t('RESET')}</Button> : ''}
                        {(status === 'ANALYZED' || status === 'STOP') && this.state.selectedLang !== Dict.t('NONE_F') ?
                            <Button
                                onClick={() => {
                                    this._reset();
                                    this.setState({
                                        selectedLang: Dict.t('NONE_F'),
                                        selectedExternalService: {},
                                        externalServices: []
                                    }, () => {
                                        document.getElementsByTagName('select')[0].value = Dict.t('NONE_F');
                                    });
                                }}
                            >{Dict.t('RESET_LANGUAGE')}</Button> : ''}
                        < Button
                            onClick={() => {
                                this._close();
                            }}
                        >{Dict.t('CLOSE')}</Button>
                    </Col>
                </Row>
                <Row>
                    {printGrid}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {this.state.csvContent.length > 0 ? <Button
                    bsStyle={this.state.blackListStatus === 'SAVING' ? "warning" : "default"}
                    onClick={() => {
                        this.setState({blackListStatus: 'SAVING'});
                        const blackListedWord = this.state.words.filter((word) => {
                            return word.blacklisted;
                        }).map((blackListedWord) => {
                            return blackListedWord.word
                        });

                        if (blackListedWord.length > 0) {
                            return TreeUtilities.createFileData(blackListedWord).then((resultData) => {
                                return Dict.call('/tree/putWordInBlackList/' + this.state.projectName + '/' + resultData.filename + '/').then((result) => {
                                    if (result === 'OK') {
                                        Notifications.showToastNotification("Blacklist aggiornata", 3000, 200);
                                        const words = this.state.words.filter((word) => {
                                            return !word.blacklisted;
                                        })

                                        const csvContent = this._createCsvContent(words);

                                        this.setState({words, csvContent}, () => {
                                            this.setState({blackListStatus: 'STOP'});
                                        });
                                    }
                                })
                            });
                        } else {
                            Notifications.showErrorToastNotification("Nessuna parola selezionata", 2000, 200);
                        }
                    }}>
                    Inserisci in blacklist
                </Button> : ''}
            </Modal.Footer>
        </Modal>;
    }
}